import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'session_end_dialog',
    initialState: false,
    reducers: {
        openSessionEndedDialog: () => true,
        closeSessionEndedDialog: () => false,
    },
});
export const { openSessionEndedDialog, closeSessionEndedDialog } = slice.actions;
export const sessionEndReducer = slice.reducer;
